import { Component, useEffect, useMemo, useRef, useState } from "react";
import { ErrorBoundary, FallbackProps, ErrorBoundaryPropsWithFallback } from "react-error-boundary";
import "./App.scss";
import { io } from "socket.io-client";
import SocketService from "./services/SocketService";
import UserService from "./services/UserService";
import SupplierService from "./services/SupplierService";
import VendorService from "./services/VendorService";
import { IUiContextModel } from "./contexts/UiContext";
import { SidebarProps } from "react-sidebar";
import UIService from "./services/UIService";
import CategoryContext from "./contexts/CategoryContext";
import { AppContextProvider } from "./contexts/AppContext";
import ICategory from "./models/ICategory";
import { toast, ToastContainer, ToastOptions } from "react-toastify";
import NotificationPositionEnum from "./models/NotificationPositionEnum";
import OwTranslate from "./components/shared/OwTranslate/OwTranslate";
import NotificationLevelEnum from "./models/NotificationLevelEnum";
import INotification from "./models/INotification";
import IErrorDTO from "./models/DTO/IErrorDTO";
import { isNil, isString } from "lodash-es";
import OwLabel from "./components/shared/OwLabel/OwLabel";
import { HeaderFnMobile } from "./components/main/HeaderFnMobile/HeaderFnMobile";
import { HeaderFnStandard } from "./components/main/HeaderFnStandard/HeaderFnStandard";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { SideNavigation } from "./components/main/SideNavigation/SideNavigation";
import UIVersionRefresh from "./components/shared/UIVersionRefresh/UIVersionRefresh";
import { Dashboard } from "./components/dashboard/Dashboard/Dashboard";
import { DashboardOrderEntrySuccess } from "./components/dashboard_order_entry/DashboardOrderEntrySuccess/DashboardOrderEntrySuccess";
import { DashboardOrderEntry } from "./components/dashboard_order_entry/DashboardOrderEntry/DashboardOrderEntry";
import Login from "./components/login/Login/Login";
import IUiSocketSetup from "./models/IUiSocketSetup";
import EndpointsEnum from "./models/EndpointsEnum";
import IOnLoadUserDTO from "./models/DTO/IOnLoadUserDTO";
import { IntercomProvider, useIntercom } from "react-use-intercom";

import ISupplierModel from "./models/ISupplierModel";
import IVendorModel from "./models/IVendorModel";
import MenuService from "./services/MenuService";
import IUserUI from "./models/IUserUI";
import qs from "qs";
import IConnection_Token from "./models/IConnection_Token";
import { AccountChangeLoader } from "./components/main/AccountChangeLoader/AccountChangeLoader";
import { UnconnectedAccount } from "./components/main/UnconnectedAccount/UnconnectedAccount";
import Orders from "./components/orders/Orders/Orders";
import { useIntl } from "react-intl";
import { OrderEntryWrapper } from "./components/order_entry/OrderEntryWrapper/OrderEntryWrapper";
import { BusinessProfile } from "./components/business/BusinessProfile/BusinessProfile";
import { BusinessIntegrations } from "./components/business/BusinessIntegrations/BusinessIntegrations";
import BusinessSettings from "./components/business/BusinessSettings/BusinessSettings";
import { OwSidebar } from "./components/shared/OwSidebar/OwSidebar";
import Modal from "react-modal";
import ISupplierSettings from "./models/ISupplierSettings";
import IThemeVariables from "./models/IThemeVariables";
import Projects from "./components/projects/Projects/Projects";
import { Clients } from "./components/clients/Clients/Clients";
import { Reports } from "./components/reports/Reports/Reports";
import { ReportsReady } from "./components/reports/ReportsReady/ReportsReady";
import SupplierUsers from "./components/users/Users/SupplierUsers/SupplierUsers";
import { IntakeForms } from "./components/intake_forms/IntakeForms/IntakeForms";
import Catalogs from "./components/catalogs/Catalogs/Catalogs";
import { CatalogOverviewWrapper } from "./components/catalogs/CatalogOverviewWrapper/CatalogOverviewWrapper";
import { PriceApproval } from "./components/orders/PriceApproval/PriceApproval";
import { UnitOfMeasureSets } from "./components/catalogs/UnitOfMeasureSets/UnitOfMeasureSets";
import Spiff from "./components/business/Spiff/Spiff";
import { PurchaseOrders } from "./components/purchase_orders/PurchaseOrders/PurchaseOrders";
import { PurchaseOrderShipmentDetailWrapper } from "./components/purchase_orders/PurchaseOrderShipmentDetailWrapper/PurchaseOrderShipmentDetailWrapper";
import { VendorSourcesFn } from "./components/purchase_orders/VendorSourcesFn/VendorSourcesFn";
import { VendorSourcesUsers } from "./components/purchase_orders/VendorSourcesUsers/VendorSourcesUsers";
import { Discounts } from "./components/discounts/Discounts/Discounts";
import { RepGroups } from "./components/rep_groups/RepGroups/RepGroups";
import { Inventory } from "./components/inventory/Inventory/Inventory";
import { Lots } from "./components/lots/Lots/Lots";
import { Serials } from "./components/inventory/Serials/Serials";
import { Warehouses } from "./components/warehouses/Warehouses/Warehouses";
import { Transfers } from "./components/warehouses/Transfers/Transfers";
import Exports from "./components/exports/Exports/Exports";
import Accounting from "./components/accounting/Accounting/Accounting";
import { RoutesView } from "./components/routes/Routes/RoutesView";
import { DailyRoutes } from "./components/routes/DailyRoutes/DailyRoutes";
import { Billing } from "./components/billing/Billing/Billing";
import { SimplePickList } from "./components/shared/SimplePickList/SimplePickList";
import { BillOfLading } from "./components/shared/BillOfLading/BillOfLading";
import PackingList from "./components/packing_list/PackingList/PackingList";
import OrderPackingList from "./components/shared/OrderPackingList/OrderPackingList";
import { OrderCreateSalesOrder } from "./components/orders/OrderCreateSalesOrder/OrderCreateSalesOrder";
import { OrderCreateInvoice } from "./components/orders/OrderCreateInvoice/OrderCreateInvoice";
import { LogOff } from "./components/logoff/LogOff/LogOff";
import { Ecommerce } from "./components/ecommerce/Ecommerce/Ecommerce";
import { SplashScreen } from "./components/main/SplashScreen/SplashScreen";
import FullScreenActivityIndicator from "./components/shared/FullScreenActivityIndicator/FullScreenActivityIndicator";
import OwButton from "./components/shared/OwButton/OwButton";
import { Dock } from "react-dock";
import { CreateTicketModal } from "./components/help/CreateTicketModal/CreateTicketModal";
import { CustomerModuleInactive } from "./components/billing/CustomerModuleInactive/CustomerModuleInactive";
import ReactJoyride, { CallBackProps, Step } from "react-joyride";
import TutorialService from "./services/TutorialService";
import ILoadUserDTO from "./models/DTO/ILoadUserDTO";
import { PurchaseOrderDetailWrapper } from "./components/purchase_orders/PurchaseOrderDetailWrapper/PurchaseOrderDetailWrapper";
import { Contacts } from "./components/accounts/SupplierVendorContacts/Contacts";
import { AccountDetailView } from "./components/shared/AccountDetailView/AccountDetailView";
import { SupplierVendorAddressesWrapper } from "./components/accounts/SupplierVendorAddressesWrapper/SupplierVendorAddressesWrapper";
import Forecast from "./components/forecast/Forecast/Forecast";
import { ForecastDetailWrapper } from "./components/forecast/ForecastDetailWrapper/ForecastDetailWrapper";
import Materials from "./components/materials/Materials/Materials";
import { Onboarding } from "./components/onboarding/Onboarding/Onboarding";
import { PickList } from "./components/pick_list/PickList/PickList";
import { PickListDetailWrapper } from "./components/pick_list/PickListDetailWrapper/PickListDetailWrapper";
import { PackingListDetailWrapper } from "./components/packing_list/PackingListDetailWrapper/PackingListDetailWrapper";
import StripeInactiveSubscription from "./components/billing/StripeInactiveSubscription/StripeInactiveSubscription";
import { OwIdleTimer } from "./components/main/OwIdleTimer/OwIdleTimer";
import { SupplierVendorsWrapper } from "./components/accounts/SupplierVendorsWrapper/SupplierVendorsWrapper";
import { VendorUsersWrapper } from "./components/accounts/VendorUsersWrapper/VendorUsersWrapper";
import IOnGetSupplierDTO from "./models/DTO/IOnGetSupplierDTO";
import pkgJson from "../package.json";
import { EcommerceOrders } from "./components/ecommerce/EcommerceOrders/EcommerceOrders";
import { EcommerceOrderDetails } from "./components/ecommerce/EcommerceOrderDetails/EcommerceOrderDetails";
import { EcommerceInvoice } from "./components/ecommerce/EcommerceInvoice/EcommerceInvoice";
import { EcommerceCheckout } from "./components/ecommerce/EcommerceCheckout/EcommerceCheckout";
import { EcommerceCheckoutComplete } from "./components/ecommerce/EcommerceCheckoutComplete/EcommerceCheckoutComplete";
import Automation from "./components/automation/Automation/Automation";
import { QuotePrintView } from "./components/orders/QuotePrintView/QuotePrintView";
import { TransferDetail } from "./components/warehouses/TransferDetail/TransferDetail";
import { TransferSlip } from "./components/warehouses/TransferSlip/TransferSlip";
import { TransferReceived } from "./components/warehouses/TransferReceived/TransferReceived";
import { DashboardEditor } from "./components/dashboard/DashboardEditor/DashboardEditor";
import Rebates from "./components/business/Rebates/Rebates";
import Commissions from "./components/business/Commissions/Commissions";
import { LabelGenerator } from "./components/labels/LabelGenerator/LabelGenerator";
import { ShipmentsWrapper } from "./components/shipments/ShipmentsWrapper/ShipmentsWrapper";
import { BatchShipmentsWrapper } from "./components/shipments/BatchShipmentsWrapper/BatchShipmentsWrapper";
import { OrdersWrapper } from "./components/orders/OrdersWrapper/OrdersWrapper";
import { BatchOrdersWrapper } from "./components/orders/BatchOrdersWrapper/BatchOrdersWrapper";
import { ChangeToOrder } from "./components/order_entry/ChangeToOrder/ChangeToOrder";
import { WayfairLogViewer } from "./components/business/BusinessIntegrations/WayfairLogViewer/WayfairLogViewer";
import INavItem from "./models/INavItem";
import TakeOffs from "./components/take_offs/TakeOffs/TakeOffs";
import { ProfileFn } from "./components/profile/ProfileFn/ProfileFn";
import { TakeOffDetailWrapper } from "./components/take_offs/TakeOffDetailWrapper/TakeOffDetailWrapper";
import { SimplePackingList } from "./components/shared/SimplePackingList/SimplePackingList";
import { PackingListDetailFn } from "./components/packing_list/PackingListDetailFn/PackingListDetailFn";
import { QuickBooksDesktopLogViewer } from "@components/business/BusinessIntegrations/QuickbooksDesktopConnect/QuickBooksDesktopLogViewer/QuickBooksDesktopLogViewer";
import { AdminActionsCircle } from "@components/admin/AdminActionsCircle/AdminActionsCircle";
import CatalogOverviewFn from "@components/catalogs/CatalogOverview/CatalogOverviewFn";
import { PurchaseOrderShipmentDetailFn } from "@components/purchase_orders/PurchaseOrderShipmentDetailFn/PurchaseOrderShipmentDetailFn";
import EcommerceView from "@components/order_entry/EcommerceView/EcommerceView";
import { EcommerceCheckoutView } from "@components/order_entry/EcommerceCheckoutView/EcommerceCheckoutView";
import { CustomImports } from "@components/business/CustomImports/CustomImports";
import { EcommerceItemDetailPage } from "@components/ecommerce/EcommerceItemDetailPage/EcommerceItemDetailPage";
import { LogService } from "@services/LogService";
import { ErrorFallback } from "./components/shared/ErrorFallback/ErrorFallback";
import { InventoryBackorders } from "@components/inventory/InventoryBackorders/InventoryBackorders";
import { HelpDock } from "@components/shared/HelpDock/HelpDock";
import { RMA } from "@components/inventory/RMA/RMA";
import { RmaDetail } from "@components/inventory/RMA/RmaDetail/RmaDetail";
import { VendorSourceDetailView } from "@components/purchase_orders/VendorSourceDetailView/VendorSourceDetailView";
import { Vehicles } from "@components/routes/Vehicles/Vehicles";
import { DailyRouteDeliveryMatrix } from "@components/routes/DailyRouteDeliveryMatrix/DailyRouteDeliveryMatrix";
import { DailyRouteDetail } from "@components/routes/DailyRouteDetail/DailyRouteDetail";
import { CatalogsWrapper } from "@components/catalogs/CatalogsWrapper/CatalogsWrapper";
import { AppDashboardConfig } from "@components/business/BusinessSettings/AppDashboardConfig/AppDashboardConfig";
import { AccountNotes } from "@components/accounts/AccountNotes/AccountNotes";

function App() {
    const INTERCOM_APP_ID = "ji300xmt";

    const navigate = useNavigate();
    const location = useLocation();
    const intl = useIntl();

    const hasSetupDataDog = useRef(false);

    const [isOnline, setIsOnline] = useState(true);

    const loadUser = () => {
        const user = UserService.getLocalUserDataFn();

        if (socket) {
            if (user?.guid) {
                const payload: ILoadUserDTO = {
                    userGuid: user.guid,
                    userToken: user.token,
                };

                socket.emit(EndpointsEnum.AppLoadUser, payload);
            } else {
                // check if there's an email or token in the url.
                // if there is, then perform a login routine.
                const hash = window.location.hash;
                let _queryString = hash.split("?")[1];

                // fallback to window.location.search
                if (!_queryString?.length) {
                    _queryString = window.location.search;
                }

                if (_queryString.length) {
                    const urlParams = new URLSearchParams(_queryString);

                    const guid = urlParams.get("guid");
                    const token = urlParams.get("token");

                    if (guid && token) {
                        const payload: ILoadUserDTO = {
                            userGuid: guid,
                            userToken: token,
                        };

                        socket.emit(EndpointsEnum.AppLoadUser, payload);
                    } else {
                        goToLoginScreen();
                    }
                } else {
                    console.log("[APP] No QueryString - Go To Login Screen");
                    goToLoginScreen();
                }
            }
        } else {
            console.log("Socket Not Active");
        }
    };

    const showNotification = (options: { message: string; level: NotificationLevelEnum }) => {
        const notification: INotification = {
            message: options.message,
            level: options.level,
            position: NotificationPositionEnum.bc,
        };

        notifyToast(null, notification);
    };

    const notifyToast = (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => {
        setShowActivityIndicator(false);

        let notification: INotification | undefined;

        if (!isNil(_notification)) {
            notification = _notification;

            if (isNil(_notification.position)) {
                notification.position = NotificationPositionEnum.bc;
            }
        } else {
            if (data) {
                notification = {
                    message: data.message,
                    level: data.level ? data.level : NotificationLevelEnum.error,
                    position: data.position ? data.position : NotificationPositionEnum.bc,
                };

                if (data.title && data.title.length) {
                    const title = data.title.toLowerCase();
                    notification.title = <OwTranslate id={title} defaultMessage={title} />;
                }
            }
        }

        if (notification && !isFormatted && data && data.message.length) {
            const message = data.message.toLowerCase();
            notification.message = <OwTranslate id={message} defaultMessage={message} />;

            if (data.title && data.title.length) {
                const title = data.title.toLowerCase();
                notification.title = <OwTranslate id={title} defaultMessage={title} />;
            }
        }

        if (notification && !isFormatted && _notification) {
            if (_notification.title && isString(_notification.title) && _notification.title.length) {
                const title = _notification.title.toLowerCase();
                notification.title = <OwTranslate id={title} defaultMessage={title} />;
            }

            if (
                _notification.message &&
                isString(_notification.message) &&
                _notification.message.length &&
                !_notification.skipMessageTranslate
            ) {
                const message = _notification.message.toLowerCase();
                notification.message = <OwTranslate id={message} defaultMessage={message} />;
            }
        }

        if (notification && !isNil(data) && !isNil(data.details)) {
            notification.title = notification.message;

            const details = data.details.toLowerCase();

            if (details.length) {
                notification.message = <OwTranslate defaultMessage={details} id={details} />;
            }

            if (!isNil(data.autoDismiss)) {
                notification.autoDismiss = data.autoDismiss;
            }

            if (!isNil(data.dismissible)) {
                notification.dismissible = data.dismissible;
            }
        }

        if (notification && sidebarOpen) {
            notification.position = NotificationPositionEnum.bc;
        }

        if (notification) {
            if (notification.clearExisting) {
                toast.dismiss();
            }

            const options: ToastOptions = {
                type: notification.level,
                position: notification.position,
            };

            let messageToast: any = null;

            if (notification.title || (isFormatted && notification.title.length)) {
                messageToast = (
                    <div>
                        <div>{notification.title}</div>
                        <div className={"text-small"}>{notification.message}</div>
                    </div>
                );
            } else if (notification.message) {
                messageToast = (
                    <div>
                        <div>{notification.message}</div>
                    </div>
                );
            }

            toast(messageToast, options);
        } else {
            console.log("notify function called without data or notification override.");
        }
    };

    const setRightSideComponentFn = (component: any) => {
        setRightSideComponent(component);
    };

    const toggleRightSide = (shouldBeVisible?: boolean) => {
        setRightSideOpen((prevState) => {
            if (!isNil(shouldBeVisible)) {
                return shouldBeVisible;
            } else {
                return !prevState;
            }
        });
    };

    const setRightSideHeaderComponentFn = (component: any) => {
        setRightHeaderComponent(component);
    };

    const setSubHeaderComponentFn = (component: any) => {
        setSubHeaderComponent(component);
    };

    const activityIndicatorStateFn = (_activityOn: boolean, _isInitialLoad?: boolean) => {
        setShowActivityIndicator(_activityOn);
    };

    const doLogout = () => {
        navigate("/logoff");
    };

    const doIdleLogout = () => {
        // Capture full pathname without query/hash, removing leading slash
        const currentRoute = location.pathname.slice(1);
        navigate("/logoff", { state: { fromIdleTimeout: true, navTo: currentRoute } });
    };

    const toggleHelpDock = () => {
        setIsDockVisible(!isDockVisible);
    };

    const [menuOpen, setMenuOpen] = useState(false);
    const [menuIconMode, setMenuIconMode] = useState(false);

    const [showHiddenFeatures, setShowHiddenFeatures] = useState(false);
    const [disableIdleTimeout, setDisableIdleTimeout] = useState(false);
    const idleTimeRemainingRef = useRef(1800); // 30 minutes in seconds

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalCloseOnEsc, setModalCloseOnEsc] = useState(false);
    const [modalCloseOnOverlayClick, setModalCloseOnOverlayClick] = useState(false);

    const toggleMenuIconMode = () => {
        setMenuIconMode((prevState) => {
            return !prevState;
        });
    };

    const toggleMenu = () => {
        setMenuOpen((prevState) => {
            return !prevState;
        });
    };

    const handleTutorialCallback = (data: CallBackProps) => {
        if (data.status === "finished") {
            const mainView = document.getElementById("mainView");

            if (mainView) {
                mainView.style.removeProperty("overflow");
            }

            setTutorial([]);
            setRunTutorial(false);
        }

        TutorialService.handleTutorialCustomActions(location.pathname, data);
    };

    const toggleCreateTicketModal = () => {
        setShowCreateTicketModal(!showCreateTicketModal);
        setIsDockVisible(false);
    };

    const setModalComponentFn = (component: Component | React.JSX.Element | null) => {
        setModalComponent(component);
    };

    const showModalFn = (shouldBeVisible?: boolean) => {
        setModalIsOpen(!isNil(shouldBeVisible) ? shouldBeVisible : !modalIsOpen);
    };

    const setModalSetupFn = (options: { modalContentClass?: string; modalOverlayClass?: string; modalStyle?: any }) => {
        if (options.modalContentClass) {
            setModalContentClass(options.modalContentClass);
        }

        if (options.modalOverlayClass) {
            setModalOverlayClass(options.modalOverlayClass);
        }

        if (options.modalStyle) {
            setModalStyle(options.modalStyle);
        }
    };

    const resetModalClassesAndStyles = () => {
        setModalContentClass("modalContentClass");
        setModalOverlayClass("modalOverlayClass");
        setModalStyle({});
        setModalCloseOnOverlayClick(false);
        setModalCloseOnEsc(false);
    };

    const getIdleTimeRemaining = () => {
        return idleTimeRemainingRef.current;
    };

    const setIdleTimeRemaining = (seconds: number) => {
        idleTimeRemainingRef.current = seconds;
    };

    const getUiContextModel = () => {
        return {
            // forceOnline,
            isOnline,
            setSidebarComponent: setSidebarComponentFn,
            toggleSidebar,
            notifyFn: notifyToast,
            showNotification: showNotification,
            setRightSideComponent: setRightSideComponentFn,
            toggleRightSide,
            setRightSideHeaderComponent: setRightSideHeaderComponentFn,
            setSubHeaderComponent: setSubHeaderComponentFn,
            subHeaderComponent,
            setActivityIndicator: activityIndicatorStateFn,
            getSidebarState: () => sidebarOpen,
            menuOpen,
            showHiddenFeatures,
            menuIconMode,
            setMenuIconMode,
            isMenuIconMode: () => menuIconMode,
            toggleMenuIconMode,
            toggleMenu,
            setModalComponent: setModalComponentFn,
            showModal: showModalFn,
            setModalSetup: setModalSetupFn,
            modalIsOpen,
            resetModalClassesAndStyles,
            isMenuOpen: () => menuOpen,
            isEcommView,
            setIsEcommView,
            cartItemCount,
            setCartItemCount,
            isCheckoutView,
            setIsCheckoutView,
            modalCloseOnEsc,
            setModalCloseOnEsc,
            setModalCloseOnOverlayClick,
            setShowHiddenFeatures,
            disableIdleTimeout,
            setDisableIdleTimeout,
            getIdleTimeRemaining,
            setIdleTimeRemaining,
        } as IUiContextModel;
    };

    const getMainViewClass = () => {
        let mainViewClass = "col-sm-8 col-md-9 col-lg-9 col-xl-10";

        if (rightSideOpen && menuOpen) {
            mainViewClass = "col-sm-4 col-md-6 col-lg-6 col-xl-8";
        }

        if (menuIconMode) {
            mainViewClass = "col flex-grow";
        }

        return mainViewClass;
    };

    const getMenuClass = () => {
        let menuClass = "col-sm-4 col-md-3 col-lg-3 col-xl-2 sideBarNavWrapper";

        if (menuIconMode) {
            menuClass = "col-md-auto sideBarNavWrapper";
        }

        return menuClass;
    };

    const [userModel, setUserModel] = useState<IUserUI>(UserService.getLocalUserDataFn());
    const [supplierModel, setSupplierModel] = useState<ISupplierModel>(SupplierService.getLocalSupplierDataFn());
    const [vendorModel, setVendorModel] = useState<IVendorModel>(VendorService.getLocalVendorDataFn());
    const [vendorUserToken, setVendorUserToken] = useState<IConnection_Token>();
    const [supplierVendorToken, setSupplierVendorToken] = useState<IConnection_Token>();
    const [supplierUserToken, setSupplierUserToken] = useState<IConnection_Token>();
    const [currentSupplierGuid, setCurrentSupplierGuid] = useState<string | undefined>();
    const [currentVendorGuid, setCurrentVendorGuid] = useState<string | undefined>();

    const socket = useMemo(() => {
        const newSocket = io(SocketService.getEndpointUrl(), {
            transports: ["websocket"],
            upgrade: false,
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            // we have to do it this way, because strict mode will do a re-render and you end up with 2 open sockets.
            autoConnect: false,
            query: { clientId: userModel?.guid },
        });
        return newSocket;
    }, []);

    const isInitialMount = useRef(true);
    const hasLoadedUser = useRef(false);

    useEffect(() => {
        // This helps minimize the wrong color theme when the user refreshs the page.
        if (supplierModel && userModel) {
            setupCustomTheme(supplierModel, userModel);
        }
    }, []);

    useEffect(() => {
        if (isInitialMount.current) {
            if (!socket.connected) {
                socket.connect(); // Ensure connection on first mount
            }
        }

        const onConnect = () => {
            console.log("Socket connected:", socket.id);
            if (!hasLoadedUser.current) {
                loadUser(); // Run loadUser only once on first connect
                hasLoadedUser.current = true;
            }
        };
        socket.on("connect", onConnect);
        socket.on("disconnect", () => console.log("Socket disconnected:", socket.id));
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        // If already connected on mount, trigger loadUser
        if (socket.connected && !hasLoadedUser.current) {
            loadUser();
            hasLoadedUser.current = true;
        }

        return () => {
            if (isInitialMount.current) {
                // console.log("Skipping disconnect during Strict Mode cleanup");
                isInitialMount.current = false;
            } else {
                // console.log("Cleaning up socket (real unmount):", socket.id);
                socket.off("connect", onConnect);
                for (const _socket of sockets) {
                    socket.off(_socket.endpoint, _socket.fn);
                }
                socket.disconnect();
            }
        };
    }, [socket]);

    const [sidebarComponent, setSidebarComponent] = useState<any>();
    const [rightHeaderComponent, setRightHeaderComponent] = useState<any>();
    const [subHeaderComponent, setSubHeaderComponent] = useState<any>();
    const [rightSideComponent, setRightSideComponent] = useState<any>();

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarMounted, setSidebarMounted] = useState(false);
    const [rightSideOpen, setRightSideOpen] = useState(false);
    const [sidebarProps, setSidebarProps] = useState<any>({});

    const [isDockVisible, setIsDockVisible] = useState(false);
    const [showCreateTicketModal, setShowCreateTicketModal] = useState(false);

    const [isEcommView, setIsEcommView] = useState(false);
    const [cartItemCount, setCartItemCount] = useState(0);

    const [isCheckoutView, setIsCheckoutView] = useState(false);

    const setSidebarComponentFn = (component: Component | React.JSX.Element | React.FC | null) => {
        setSidebarComponent(component);
    };

    const toggleSidebar = (shouldBeVisible?: boolean, _sidebarProps?: SidebarProps) => {
        setSidebarOpen((prevSidebarOpen) => {
            const _sidebarOpen = !isNil(shouldBeVisible) ? shouldBeVisible : !prevSidebarOpen;

            setSidebarProps(_sidebarProps);
            // setSidebarComponent(_sidebarOpen ? sidebarComponent : null);
            return _sidebarOpen; // Return the new state
        });
    };

    const [uiContext, setUiContext] = useState<IUiContextModel>(getUiContextModel());
    const [category, setCategory] = useState<ICategory>();
    const [forceOnline, setForceOnline] = useState(false);
    const [position, setPosition] = useState<any>("relative");
    const [name, setName] = useState(userModel?.name || "");

    /**
     * This useEffect dependency array is responsible for reflecting the latest values for any useState variables
     * on the UI Context Model. You will get stale data if you don't update as necessary.
     */
    useEffect(() => {
        setUiContext(getUiContextModel());
    }, [
        menuOpen,
        menuIconMode,
        cartItemCount,
        isEcommView,
        isCheckoutView,
        showHiddenFeatures,
        disableIdleTimeout,
        modalIsOpen,
        modalCloseOnEsc,
        rightSideOpen,
    ]);

    // Close right sidebar when navigating to ecomm orders or shipments
    useEffect(() => {
        if (location.pathname === "/ecomm/orders" || location.pathname === "/ecomm/shipments") {
            setRightSideOpen(false);
            setRightSideComponent(null);
        }
    }, [location.pathname]);

    const [isLoading, setIsLoading] = useState(true);
    const [initialLoad, setInitialLoad] = useState(true);

    const [showActivityIndicator, setShowActivityIndicator] = useState(false);

    const [showNewVersionIndicator, setShowNewVersionIndicator] = useState(false);
    const [minUiVersion, setMinUiVersion] = useState<string>("0.0.0");

    const hasTutorial = () => {
        let tutorialAvailable = false;

        switch (location.pathname) {
            case "/dashboard":
            case "/catalogs":
            case "/orders":
            case "/shipments":
            case "/dashboard/config":
                tutorialAvailable = true;
                break;
        }

        if (/catalogs\/\S+/.test(location.pathname)) {
            tutorialAvailable = true;
        }

        if (/orders\/\S+\/entry/.test(location.pathname)) {
            // tutorialAvailable = true;
            // some type of float issue.
        }

        return tutorialAvailable;
    };

    const [isOnboardingRoute, setIsOnboardingRoute] = useState(false);
    const [hideNav, setHideNav] = useState(false);

    const [routes, setRoutes] = useState<INavItem[]>([]);
    const [routeDetailsSet, setRouteDetailsSet] = useState(false);

    const [modalComponent, setModalComponent] = useState<any>(null);
    const [modalStyle, setModalStyle] = useState({});
    const [modalContentClass, setModalContentClass] = useState("modalContentClass");
    const [modalOverlayClass, setModalOverlayClass] = useState("modalOverlayClass");

    const [showCustomerModuleInactive, setShowCustomerModuleInactive] = useState(false);

    const [tutorial, setTutorial] = useState<Step[]>();
    const [runTutorial, setRunTutorial] = useState(false);
    const [allowTutorialClicks, setAllowTutorialClicks] = useState(false);

    const [didInitialMount, setDidInitialMount] = useState(false);
    const [appConnectDetail, setAppConnectDetails] = useState<any>();

    const mainViewClass = getMainViewClass();
    const menuClass = getMenuClass();

    // const menuNavRef = useRef();
    // const mainContentRef = useRef<HTMLDivElement>();

    const onLoadUser = async (data: IOnLoadUserDTO) => {
        // take these from local storage maybe?
        setCurrentSupplierGuid(supplierModel?.guid);
        setCurrentVendorGuid(vendorModel?.guid);

        const setupData = await UserService.transformUserData(data);

        if (!setupData.supplierModel?.guid) {
            setHideNav(true);
            setIsLoading(false);
            setInitialLoad(false);
            setUserModel(setupData.userModel);
            setSupplierModel(setupData.supplierModel);
            setVendorModel(setupData.vendorModel);

            activityIndicatorStateFn(false, true);
            navigate("/unconnected");
        }

        window.addEventListener("storage", (event) => {
            if (event.key === "logout-event") {
                doLogout();
            }
        });

        UserService.saveForceOnline(forceOnline);

        setupCustomTheme(setupData.supplierModel, setupData.userModel);

        // TODO: do we need this?
        // setRemainingRouteDetails(setupData.userModel, setupData.supplierModel, setupData.vendorModel);

        let ecomView = false;

        if (setupData.supplierModel.has_ecommerce_view) {
            if (setupData.supplierModel.ecommerce_default_view) {
                ecomView = true;
            }
        }

        // UIService.ecommerceView$().next(ecomView);

        setShowCustomerModuleInactive(!setupData.userModel?.isSupplierUser && !setupData.supplierModel.has_customer_module);

        setName(setupData.name);
        setIsLoading(false);
        setUserModel(setupData.userModel);
        setSupplierModel(setupData.supplierModel);
        setVendorModel(setupData.vendorModel);
        setMinUiVersion(data.system.ui_version);
        setInitialLoad(false);
        setSupplierVendorToken(setupData.supplierVendorToken);
        setVendorUserToken(setupData.vendorUserToken);
        setSupplierUserToken(setupData.supplierUserToken);

        // Clear right sidebar when switching accounts to ensure fresh component mount
        setRightSideOpen(false);
        setRightSideComponent(null);

        UserService.saveUserData(setupData.userModel);
        SupplierService.saveSupplierData(setupData.supplierModel);
        VendorService.saveVendorData(setupData.vendorModel);

        if (!hasSetupDataDog.current) {
            const env = process.env.NODE_ENV as "production" | "development";
            if (env) {
                UIService.setupDataDog(setupData.userModel, env);
                hasSetupDataDog.current = true;
            }
        }

        // do a check and see if the user is an ecomm user?

        // const routeDetail = MenuService.setRemainingRouteDetails(
        //     setupData.userModel,
        //     setupData.supplierModel,
        //     setupData.vendorModel,
        //     setupData.vendorUserToken,
        //     setupData.supplierVendorToken
        // );
        // setRoutes(routeDetail);
    };

    useEffect(() => {
        if (!isLoading && !initialLoad && userModel && supplierModel && vendorModel) {
            determineInitialViewAndSetupMenu();
        }
    }, [initialLoad, supplierModel, userModel, vendorModel]);

    const sortRoutes = (routes: INavItem[]) => {
        const currentToken = userModel.isSupplierUser ? userModel.supplierUserToken : userModel.vendorUserToken;

        if (currentToken?.settings?.menu_id_order) {
            // Sort routes by their order in menu_id_order
            const sortedRoutes = [...routes].sort((a, b) => {
                const orderA = currentToken?.settings?.menu_id_order?.[a.menuId]?.order ?? 999;
                const orderB = currentToken?.settings?.menu_id_order?.[b.menuId]?.order ?? 999;
                return orderA - orderB;
            });

            return sortedRoutes;
        } else {
            return routes;
        }
    };

    const setEcommUserRoutes = () => {
        const ecommRoutes = MenuService.getEcommRoutes(supplierModel);

        const sortedRoutes = sortRoutes(ecommRoutes);

        setRoutes(sortedRoutes);
    };

    const setStandardUserRoutes = () => {
        const routeDetail = MenuService.setRemainingRouteDetails(
            userModel,
            supplierModel,
            vendorModel,
            vendorUserToken,
            supplierVendorToken
        );

        const sortedRoutes = sortRoutes(routeDetail);

        if (!sortedRoutes.length) {
            LogService.error("No routes found for user", {
                routeDetail,
                menuOpen,
                hideNav,
                isOnboardingRoute,
                supplierGuid: supplierModel.guid,
            });
        }

        setRoutes(sortedRoutes);
    };

    /**
     * Function handle navigating the user to the right screen on load / login and setting up the menu items.
     */
    const determineInitialViewAndSetupMenu = () => {
        activityIndicatorStateFn(false, true);
        if (!isInitialMount) {
            // autoListenSockets();
        }

        // initial views are:

        // 1 - ui version check (outdated ui version)
        // 2 - login screen - no nav
        // 3 - unconnected account (no user tokens)
        // 4 - user onboarding (admin supplier user only atm)
        // 5 - if currently loaded user, and refresh, current route stays
        // 6 - user main landing
        // - ecomm ordering
        // - dashboard ordering
        // - dashboard
        // - navTo from url

        const result = UIService.determineInitialViewAndSetupMenu({
            minUiVersion,
            pkgJsonVersion: pkgJson.version,
            userModel,
            supplierModel,
            vendorModel,
            supplierVendorToken,
            vendorUserToken,
            supplierUserToken,
        });

        if (!result.isMinimumVersion) {
            setShowNewVersionIndicator(true);
            setDidInitialMount(true);
        }

        // Onboarding Users
        if (result.isOnboarding) {
            if (result.path?.to) {
                navigate(result.path.to);
            }
            activityIndicatorStateFn(false);
            setIsLoading(false);
            return;
        }

        // If Nav To In the URL
        if (result.performNavTo) {
            // Determine user type and set up routes before navigation
            if (result.isEcommUser || (!userModel?.isSupplierUser && vendorModel?.is_ecomm_user)) {
                setEcommUserRoutes();
            } else {
                setStandardUserRoutes();
            }

            // Now perform the navigation
            performNavTo();
            return;
        }

        // If Dashboard Order Entry

        if (result.isDashboardOrderEntry) {
            setStandardUserRoutes();

            if (result.path?.to) {
                navigate(result.path.to);
            }
            return;
        } else if (result.isEcommUser) {
            setEcommUserRoutes();

            if (result.path?.to) {
                navigate(result.path.to);
            } else if (result.path?.pathname) {
                navigate({
                    pathname: result.path.pathname,
                    search: result.path.search || "",
                });
            }
        } else {
            // just setup the standard routes...don't navigate
            setStandardUserRoutes();

            // we don't set a standard route here so the user will not navigate to /dashboard on refresh
            if (result.path?.to) {
                navigate(result.path.to);
            }
        }

        // Not sure?
        // if (!initialLoad && (currentSupplierGuid !== supplierModel?.guid || currentVendorGuid !== vendorModel?.guid)) {
        //     if (!userModel?.isSupplierUser && vendorModel?.is_ecomm_user) {
        //         setEcommUserRoutes();
        //
        //         if (location.pathname !== "/ecomm") {
        //             navigate("/ecomm");
        //         }
        //     }
        // }

        // Otherwise send to the Dashboard screen
        // if (!routes.length) {
        //     setStandardUserRoutes();
        //
        //     if (location.pathname.indexOf("login") !== -1) {
        //         navigate({
        //             pathname: "/dashboard",
        //         });
        //     }
        // }
        // }
    };

    const getLightThemeVariables = (): IThemeVariables => {
        return UIService.getLightThemeVariables();
    };

    const setupCustomTheme = (supplier: ISupplierModel, user: IUserUI, preview?: boolean) => {
        // remove the old one (if applicable);
        const oldStyle = document.querySelector('[title="theme-type"]');

        if (oldStyle) {
            oldStyle.remove();
        }

        let supplierSettings: ISupplierSettings;

        if (isString(supplier.settings)) {
            supplierSettings = JSON.parse(supplier.settings);
        } else {
            supplierSettings = supplier.settings || { theme: { type: "DARK" } };
        }

        const { themeType, custom_light, custom_dark } = UIService.getThemeType(supplier, user, preview);

        let hasNonDarkStdTheme = false;

        let theme: IThemeVariables | undefined;

        if (themeType === "LIGHT" && custom_light && supplierSettings.theme.allowCustomLight) {
            hasNonDarkStdTheme = true;
            theme = custom_light || {};
            theme!.overlayColor = "rgba(0,0,0,0.6)";
        } else if (themeType === "DARK" && custom_dark && supplierSettings.theme.allowCustomDark) {
            hasNonDarkStdTheme = true;
            theme = custom_dark || {};
            theme!.overlayColor = "rgba(0,0,0,0.9)";
        } else if (themeType === "LIGHT") {
            hasNonDarkStdTheme = true;
            theme = getLightThemeVariables();
        }

        if (hasNonDarkStdTheme && theme) {
            const $style = document.createElement("style");
            $style.title = "theme-type";
            document.head.appendChild($style);

            $style.innerHTML = `
        :root {
            --highlight-color-text: ${theme.highlightColorText};
            --highlight-color: ${theme.highlightColor};
            --tracker-highlight-color: ${theme.trackerHighlightColor};
            --main-bg-color: ${theme.mainBgColor};
            --secondary-bg-color: ${theme.secondaryBgColor};
            --bs-secondary-color: ${theme.mainTextColor};
            --minor-bg-color: ${theme.minorBgColor};
            --main-text-color: ${theme.mainTextColor};
            --center-view-bg-color: ${theme.centerViewBgColor};
            --tab-panel-bg: ${theme.tabPanelBg};
            --table-odd-rows: ${theme.tableOddRows};
            --table-even-rows: ${theme.tableEvenRows};
            --table-highlight-row: ${theme.tableHighlightRow};
            --table-hover-row: ${theme.tableHoverRow};
            --overlay-color: ${theme.overlayColor};
                }
        body {
            color: var(--main-text-color);
        }
        .btn-primary {
            background-color: var(--primary);
            border-color: var(--primary)
        }`;
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setModalComponent(null);
        resetModalClassesAndStyles();
    };

    const onGetSupplier = (data: IOnGetSupplierDTO) => {
        SupplierService.saveSupplierData(data.supplierModel);

        setRouteDetailsSet(false);
        setSupplierModel(data.supplierModel);
    };

    const onUpdateSupplierSettings = () => {
        setRouteDetailsSet(false);

        loadUser();
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.Notify, fn: notifyToast },
        { endpoint: EndpointsEnum.AppOnLoadUser, fn: onLoadUser },
        { endpoint: EndpointsEnum.SupplierOnGetSupplier, fn: onGetSupplier },
        { endpoint: EndpointsEnum.SupplierOnUpdateSupplierSettings, fn: onUpdateSupplierSettings },
        { endpoint: EndpointsEnum.SupplierOnUpdateSupplier, fn: onUpdateSupplierSettings },
    ];

    useEffect(() => {
        const observer = new MutationObserver(() => {
            if (window.showHiddenFeatures) {
                setShowHiddenFeatures(true);
            }
        });

        // Observe changes to the showHiddenFeatures property on the window object
        const observeShowHiddenFeatures = () => {
            Object.defineProperty(window, "showHiddenFeatures", {
                set: (value) => {
                    if (value === true) {
                        setShowHiddenFeatures(true);
                    }
                },
                configurable: true, // Allow redefinition
            });
        };

        // Initial observation
        observeShowHiddenFeatures();

        // Clean up the observer
        return () => {
            observer.disconnect();
            // Reset the property instead of deleting
            Object.defineProperty(window, "showHiddenFeatures", {
                value: false,
                writable: true, // Allow modifications later if needed
                configurable: true,
                enumerable: true,
            });
        };
    }, [setShowHiddenFeatures]);

    // useEffect(() => {
    //     if (!routeDetailsSet) {
    //         if (userModel && supplierModel && vendorModel) {
    //             // const initRoutes = MenuService.setInitialRoutes(userModel, vendorUserToken, supplierVendorToken);
    //             const routeDetail = MenuService.setRemainingRouteDetails(userModel, supplierModel, vendorModel, vendorUserToken, supplierVendorToken);
    //
    //             setRoutes(routeDetail);
    //             setRouteDetailsSet(true);
    //         }
    //     }
    // }, [supplierModel, routeDetailsSet]);

    useEffect(() => {
        if (sidebarOpen) {
            document.body.classList.add("noscroll");

            // calculate the sidebar height if mobile device
            const vh = window.innerHeight * 0.01;
            // console.log("window.innerHeight", window.innerHeight);
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        } else {
            document.body.classList.remove("noscroll");
        }
    }, [sidebarOpen]);

    // Delay unmounting the sidebar so the backdrop absorbs stray clicks during the close animation
    useEffect(() => {
        if (sidebarOpen) {
            setSidebarMounted(true);
        } else {
            const timer = setTimeout(() => setSidebarMounted(false), 350);
            return () => clearTimeout(timer);
        }
    }, [sidebarOpen]);

    // useEffect(() => {
    //     UIService.menuOpen$().next(menuOpen);
    // }, [menuOpen])

    const toggleTutorial = () => {
        let loadTutorial: Step[] = [];
        let allowClicks = false;

        switch (location.pathname) {
            case "/dashboard":
                loadTutorial = TutorialService.getDashboardTutorial();
                break;

            case "/catalogs":
                loadTutorial = TutorialService.getCatalogsTutorial();
                break;

            case "/orders":
                loadTutorial = TutorialService.getOrdersTutorial();
                break;

            case "/shipments":
                loadTutorial = TutorialService.getShipmentsTutorial(userModel);
                allowClicks = true;
                break;

            case "/dashboard/config":
                loadTutorial = TutorialService.getDashboardEditorTutorial();
                allowClicks = true;
                break;
        }

        if (/catalogs\/\S+/.test(location.pathname)) {
            loadTutorial = TutorialService.getCatalogOverviewTutorial();
        }

        if (/orders\/\S+\/entry/.test(location.pathname)) {
            loadTutorial = TutorialService.getOrderEntryTutorial();
        }

        setTutorial(loadTutorial);
        setRunTutorial(true);
        setAllowTutorialClicks(allowClicks);
    };

    const profileModel = supplierModel;
    //
    // if (!isLoginPath && userModel && !userModel.isSupplierUser) {
    //     profileModel = vendorModel;
    // }

    const performNavTo = (): boolean => {
        // Remove the leading '?' from window.location.search
        const parsedSearch = qs.parse(window.location.search.slice(1));

        let navTo = parsedSearch.navTo;

        let performedNavTo = false;

        if (!isNil(navTo) && isString(navTo)) {
            if (navTo[0] !== "/") {
                navTo = "/" + navTo;
            }

            navigate(navTo);
            performedNavTo = true;
        }

        return performedNavTo;
    };

    const goToLoginScreen = () => {
        let search = "";

        if (location.search) {
            search = location.search;
        } else if (location.pathname !== "/login" && location.pathname !== "/") {
            search = `?navTo=${location.pathname}`;
        }

        navigate({
            pathname: "/login",
            search: search,
        });
        setShowActivityIndicator(false);
        setIsLoading(false);
    };

    return (
        <AppContextProvider
            userModel={userModel}
            vendorModel={vendorModel}
            supplierModel={supplierModel}
            uiContext={uiContext}
            socket={socket}>
            <CategoryContext.Provider value={{ category, setFn: setCategory }}>
                <div className={"App position-relative"} id={"App"}>
                    <div
                        className={"container-fluid ps-0 pe-0 w-100 " + (sidebarOpen ? "overflow-hidden h-100 " : "d-flex flex-column")}
                        style={{
                            minHeight: "100dvh",
                            maxHeight: "100dvh",
                            position,
                        }}>
                        {!UIService.isLoginPath() ? <SplashScreen /> : null}

                        {socket ? (
                            <>
                                {userModel?.isSupplierUser && !supplierModel.subscription_active ? (
                                    <StripeInactiveSubscription
                                        userModel={userModel}
                                        supplierModel={supplierModel}
                                        socket={socket}
                                        logoutFn={doLogout}
                                    />
                                ) : null}

                                {!userModel?.isSupplierUser && supplierModel.disable_account ? (
                                    <StripeInactiveSubscription
                                        userModel={userModel}
                                        supplierModel={supplierModel}
                                        socket={socket}
                                        logoutFn={doLogout}
                                    />
                                ) : null}

                                {!disableIdleTimeout ? <OwIdleTimer logoutFn={doIdleLogout} /> : null}

                                {showCustomerModuleInactive ? <CustomerModuleInactive logoutFn={doLogout} /> : null}

                                <FullScreenActivityIndicator showActivityIndicator={showActivityIndicator} />

                                {isOnboardingRoute || hideNav ? null : (
                                    <HeaderFnMobile
                                        isSupplierUser={userModel?.isSupplierUser}
                                        isOnline={isOnline}
                                        routes={routes}
                                        toggleHelpDock={toggleHelpDock}
                                        doLogout={doLogout}
                                        menuIconMode={menuIconMode}
                                    />
                                )}

                                {/* Desktop Hamburger Menu */}
                                {isOnboardingRoute || hideNav ? null : (
                                    <HeaderFnStandard
                                        vendorModel={vendorModel}
                                        menuIconMode={uiContext.menuIconMode}
                                        name={name}
                                        toggleMenuIconMode={uiContext.toggleMenuIconMode}
                                        setMenuNavRef={(e: any) => {}}
                                        toggleMenu={uiContext.toggleMenu}
                                        menuOpen={uiContext.menuOpen}
                                        rightSideOpen={rightSideOpen}
                                        toggleHelpDock={toggleHelpDock}
                                        doLogout={doLogout}
                                        mainViewClass={mainViewClass}
                                        menuClass={menuClass}
                                        isOnline={isOnline}
                                        supplierModel={supplierModel}
                                        userModel={userModel}
                                        notifyFn={uiContext.notifyFn}
                                        setActivityIndicator={uiContext.setActivityIndicator}
                                        toggleTutorial={toggleTutorial}
                                        hasTutorial={hasTutorial}
                                        hideMenuIconMode={!!vendorModel?.is_ecomm_user}
                                        rightHeaderComponent={rightHeaderComponent}
                                    />
                                )}

                                {/* Main */}
                                <div
                                    id={"main-content"}
                                    className={"main-content position-relative " + (sidebarOpen ? "" : "")}
                                    style={{ flex: "1 1" }}>
                                    <SideNavigation menuOpen={menuOpen} menuIconMode={menuIconMode} menuClass={menuClass} routes={routes} />

                                    <div className={(menuOpen || rightSideOpen ? mainViewClass : "col-12") + " .g-0"}>
                                        {subHeaderComponent ? subHeaderComponent : null}

                                        <div id={"mainView"} className={"mainView " + "gutter"}>
                                            <ErrorBoundary
                                                FallbackComponent={ErrorFallback}
                                                onError={(error, componentStack) => {
                                                    console.log("error", error);
                                                    console.log("componentStack", componentStack);

                                                    // Report to DataDog
                                                    LogService.logReactError(error, componentStack, {
                                                        userGuid: userModel?.guid,
                                                        userName: userModel?.name,
                                                        supplierGuid: supplierModel?.guid,
                                                        vendorGuid: vendorModel?.guid,
                                                        pathname: location.pathname,
                                                        timestamp: new Date().toISOString(),
                                                    });
                                                }}
                                                onReset={() => {
                                                    console.log("reset");
                                                }}>
                                                {showNewVersionIndicator ? <UIVersionRefresh uiVersion={minUiVersion} /> : null}

                                                <ReactJoyride
                                                    steps={tutorial || []}
                                                    callback={handleTutorialCallback}
                                                    run={runTutorial}
                                                    continuous={true}
                                                    spotlightClicks={allowTutorialClicks}
                                                />

                                                <Routes>
                                                    <Route path="/login">
                                                        <Route index element={<Login />} />
                                                    </Route>

                                                    {/**
                                                     * All of these routes require a user to be logged in
                                                     * and their data available
                                                     */}
                                                    {userModel?.id && supplierModel?.id && vendorModel?.id ? (
                                                        <>
                                                            <Route path={"/accounting_change/loading"} element={<AccountChangeLoader />} />
                                                            <Route
                                                                path={"/unconnected"}
                                                                element={<UnconnectedAccount logout={doLogout} />}
                                                            />

                                                            <Route
                                                                path={"/projects"}
                                                                element={
                                                                    <Projects
                                                                        userModel={userModel}
                                                                        supplierModel={supplierModel}
                                                                        vendorModel={vendorModel}
                                                                        socket={socket}
                                                                        notifyFn={uiContext.notifyFn}
                                                                        toggleSidebar={uiContext.toggleSidebar}
                                                                        setSidebarComponent={uiContext.setSidebarComponent}
                                                                        setActivityIndicator={uiContext.setActivityIndicator}
                                                                    />
                                                                }
                                                            />

                                                            <Route path={"/clients"} element={<Clients />} />

                                                            <Route path={"/reports"}>
                                                                <Route index element={<ReportsReady />} />
                                                                <Route path={":guid"} element={<Reports />} />
                                                            </Route>

                                                            <Route
                                                                path={"/users"}
                                                                element={
                                                                    <SupplierUsers
                                                                        history={navigate}
                                                                        location={location}
                                                                        socket={socket}
                                                                        notifyFn={uiContext.notifyFn}
                                                                        setActivityIndicator={uiContext.setActivityIndicator}
                                                                        userModel={userModel}
                                                                        supplierModel={supplierModel}
                                                                        setSidebarComponent={uiContext.setSidebarComponent}
                                                                        toggleSidebar={uiContext.toggleSidebar}
                                                                    />
                                                                }
                                                            />

                                                            {["/customers", "/vendors", "/dealers", "/retailers", "resellers"].map(
                                                                (path) => (
                                                                    <Route key={path} path={path}>
                                                                        <Route index element={<SupplierVendorsWrapper />} />
                                                                        <Route path={"users"} element={<VendorUsersWrapper />} />
                                                                        <Route
                                                                            path={":guid/addresses"}
                                                                            element={<SupplierVendorAddressesWrapper />}
                                                                        />
                                                                        <Route path={path + "/notes"} element={<AccountNotes />} />
                                                                    </Route>
                                                                )
                                                            )}

                                                            <Route path={"/account"}>
                                                                <Route path={":guid/contacts"} element={<Contacts />} />
                                                                <Route path={":guid/detail"} element={<AccountDetailView />} />
                                                            </Route>

                                                            <Route path={"/intake_forms"} element={<IntakeForms />} />

                                                            <Route path={"/dashboard"}>
                                                                <Route
                                                                    index
                                                                    element={<Dashboard isOnline={forceOnline || isOnline} />}
                                                                    key={location.pathname}
                                                                />
                                                                <Route
                                                                    path={"ordering"}
                                                                    element={
                                                                        <DashboardOrderEntry
                                                                            isOnline={forceOnline || isOnline}
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                        />
                                                                    }
                                                                />

                                                                <Route
                                                                    path={"ordering/success/:orderName/:orderGuid"}
                                                                    element={<DashboardOrderEntrySuccess />}
                                                                />

                                                                <Route
                                                                    path={"config"}
                                                                    element={<DashboardEditor vendorModel={vendorModel} />}
                                                                />
                                                            </Route>

                                                            <Route path={"/ecomm"}>
                                                                <Route index element={<Ecommerce />} />
                                                                <Route path={"orders"} element={<EcommerceOrders />} />
                                                                <Route path={"orders/details/:guid"} element={<EcommerceOrderDetails />} />
                                                                <Route path={"orders/invoice/:guid"} element={<EcommerceInvoice />} />
                                                                <Route path={"checkout"} element={<EcommerceCheckout />} />
                                                                <Route path={"checkout/complete"} element={<EcommerceCheckoutComplete />} />
                                                                <Route path={"shipments"} element={<ShipmentsWrapper />} />
                                                                <Route
                                                                    path={"item/:sku/:guid"}
                                                                    element={<EcommerceItemDetailPage isEcommerce={true} />}
                                                                />
                                                            </Route>

                                                            <Route path={"/deals"}>
                                                                <Route index element={<OrdersWrapper />} />
                                                                <Route path={":order_guid/entry"} element={<OrderEntryWrapper />} />
                                                            </Route>

                                                            <Route path={"/quotes"}>
                                                                <Route index element={<OrdersWrapper isQuotes={true} />} />

                                                                <Route path=":order_guid/entry" element={<OrderEntryWrapper />} />

                                                                <Route path=":order_guid/ecom" element={<EcommerceView />} />

                                                                <Route
                                                                    path=":order_guid/ecom/checkout"
                                                                    element={<EcommerceCheckoutView />}
                                                                />

                                                                <Route path={":guid/print"} element={<QuotePrintView />} />

                                                                <Route path={"change/:guid"} element={<ChangeToOrder />} />
                                                            </Route>

                                                            <Route path={"/templates"}>
                                                                <Route index element={<OrdersWrapper isTemplates={true} />} />

                                                                <Route path=":order_guid/entry" element={<OrderEntryWrapper />} />

                                                                <Route path=":order_guid/ecom" element={<EcommerceView />} />

                                                                <Route
                                                                    path=":order_guid/ecom/checkout"
                                                                    element={<EcommerceCheckoutView />}
                                                                />
                                                            </Route>

                                                            <Route path={"/orders"}>
                                                                <Route index element={<OrdersWrapper />} />

                                                                <Route path=":order_guid/entry" element={<OrderEntryWrapper />} />

                                                                <Route path=":order_guid/ecom" element={<EcommerceView />} />

                                                                <Route
                                                                    path=":order_guid/ecom/checkout"
                                                                    element={<EcommerceCheckoutView />}
                                                                />

                                                                <Route path={"change/:guid"} element={<ChangeToOrder />} />

                                                                <Route
                                                                    path={"price_approval"}
                                                                    element={
                                                                        <PriceApproval
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            isOnline={isOnline}
                                                                        />
                                                                    }
                                                                />

                                                                <Route path={"pick_list"} element={<SimplePickList />} />

                                                                <Route path={"bill_of_lading"} element={<BillOfLading />} />

                                                                {/*<Route path={"packing_list"}*/}
                                                                {/*       element={<OrderPackingList*/}
                                                                {/*           socket={socket}*/}
                                                                {/*           notifyFn={uiContext.notifyFn}*/}
                                                                {/*           setActivityIndicator={uiContext.setActivityIndicator}*/}
                                                                {/*           setSidebarComponent={uiContext.setSidebarComponent}*/}
                                                                {/*           toggleSidebar={uiContext.toggleSidebar}*/}
                                                                {/*           userModel={userModel}*/}
                                                                {/*           supplierModel={supplierModel}*/}
                                                                {/*           toggleMenu={uiContext.toggleMenu}*/}
                                                                {/*           history={navigate}*/}
                                                                {/*           location={location}*/}
                                                                {/*       />}/>*/}

                                                                <Route path={"packing_list"} element={<SimplePackingList />} />

                                                                <Route
                                                                    path={"sales_order"}
                                                                    element={<OrderCreateSalesOrder toggleMenu={uiContext.toggleMenu} />}
                                                                />

                                                                <Route
                                                                    path={"invoice"}
                                                                    element={<OrderCreateInvoice toggleMenu={uiContext.toggleMenu} />}
                                                                />

                                                                <Route path={"batch"} element={<BatchOrdersWrapper />} />
                                                            </Route>

                                                            <Route path={"/uom-sets"} element={<UnitOfMeasureSets />} />

                                                            <Route path={"/catalogs"}>
                                                                <Route index element={<CatalogsWrapper />} />
                                                                <Route path="old/:guid" element={<CatalogOverviewWrapper />} />

                                                                <Route path=":guid" element={<CatalogOverviewFn />} />
                                                            </Route>

                                                            <Route path={"/business"}>
                                                                <Route
                                                                    path={"profile"}
                                                                    element={<BusinessProfile profileModel={profileModel} />}
                                                                />
                                                                <Route path={"integrations"}>
                                                                    <Route index element={<BusinessIntegrations />} />
                                                                    <Route path={"qbd/logs"} element={<QuickBooksDesktopLogViewer />} />
                                                                </Route>
                                                                <Route path={"settings"}>
                                                                    <Route index element={<BusinessSettings />} />
                                                                    <Route path={"app-dashboard-config"} element={<AppDashboardConfig />} />
                                                                </Route>
                                                                <Route
                                                                    path={"spiff"}
                                                                    element={
                                                                        <Spiff
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            supplierModel={supplierModel}
                                                                            userModel={userModel}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                        />
                                                                    }
                                                                />

                                                                <Route
                                                                    path={"rebates"}
                                                                    element={
                                                                        <Rebates
                                                                            supplierModel={supplierModel}
                                                                            userModel={userModel}
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                        />
                                                                    }
                                                                />

                                                                <Route path={"commissions"} element={<Commissions />} />

                                                                <Route path={"custom-imports"} element={<CustomImports />} />
                                                            </Route>

                                                            <Route path={"/purchase_orders"}>
                                                                <Route index element={<PurchaseOrders />} />
                                                                <Route path={":guid"} element={<PurchaseOrderDetailWrapper />} />
                                                                {/* <Route path={"process_shipment/:guid"}
                                                                                    element={
                                                                                        <PurchaseOrderShipmentDetailWrapper/>}/> */}
                                                                <Route
                                                                    path={"process_shipment/:guid"}
                                                                    element={<PurchaseOrderShipmentDetailFn />}
                                                                />
                                                            </Route>

                                                            <Route path={"/vendor_sources"}>
                                                                <Route index element={<VendorSourcesFn />} />
                                                                <Route path={":guid/detail"} element={<VendorSourceDetailView />} />
                                                                <Route path={"users"} element={<VendorSourcesUsers />} />
                                                            </Route>

                                                            <Route path={"/labels/generator"}>
                                                                <Route index element={<LabelGenerator />} />
                                                            </Route>

                                                            <Route path={"/discounts"}>
                                                                <Route index element={<Discounts />} />
                                                            </Route>

                                                            <Route path={"/rep-groups"}>
                                                                <Route index element={<RepGroups />} />
                                                            </Route>

                                                            <Route path={"/inventory"}>
                                                                <Route index element={<Inventory />} />

                                                                <Route path={"lots"} element={<Lots />} />

                                                                <Route path={"serials"} element={<Serials />} />

                                                                <Route path={"warehouses"} element={<Warehouses />} />

                                                                <Route path={"backorders/"} element={<InventoryBackorders />} />
                                                                <Route path={"backorders/:catalogGuid"} element={<InventoryBackorders />} />

                                                                <Route path={"transfers"} element={<Transfers />} />

                                                                <Route path={"transfers/:guid"} element={<TransferDetail />} />

                                                                <Route path={"transfers/:guid/slip"} element={<TransferSlip />} />

                                                                <Route path={"transfers/:guid/received"} element={<TransferReceived />} />

                                                                <Route path={"rma"} element={<RMA />} />

                                                                <Route path={"rma/:guid"} element={<RmaDetail />} />
                                                            </Route>

                                                            <Route path={"/exports"}>
                                                                <Route
                                                                    index
                                                                    element={
                                                                        <Exports
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            userModel={userModel}
                                                                            supplierModel={supplierModel}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                        />
                                                                    }
                                                                />
                                                            </Route>

                                                            <Route path={"/accounting"}>
                                                                <Route
                                                                    index
                                                                    element={
                                                                        <Accounting
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            userModel={userModel}
                                                                            supplierModel={supplierModel}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                            vendorModel={vendorModel}
                                                                        />
                                                                    }
                                                                />
                                                            </Route>

                                                            <Route path={"/routes"}>
                                                                <Route index element={<RoutesView />} />

                                                                <Route path={"daily"}>
                                                                    <Route index element={<DailyRoutes />} />
                                                                    <Route path={"packing_list"} element={<SimplePackingList />} />
                                                                    <Route path={"pick_list"} element={<SimplePickList />} />
                                                                    <Route
                                                                        path={"delivery_matrix"}
                                                                        element={<DailyRouteDeliveryMatrix />}
                                                                    />
                                                                    <Route path={":guid/detail"} element={<DailyRouteDetail />} />
                                                                </Route>

                                                                <Route path={"vehicles"} element={<Vehicles />} />
                                                            </Route>

                                                            <Route path={"/shipments"}>
                                                                <Route index element={<ShipmentsWrapper />} />
                                                                <Route path={"batch"} element={<BatchShipmentsWrapper />} />
                                                                <Route
                                                                    path={"packing_list"}
                                                                    element={
                                                                        <OrderPackingList
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            userModel={userModel}
                                                                            supplierModel={supplierModel}
                                                                            toggleMenu={uiContext.toggleMenu}
                                                                            history={navigate}
                                                                            location={location}
                                                                        />
                                                                    }
                                                                />
                                                            </Route>

                                                            <Route path={"/billing"}>
                                                                <Route index element={<Billing />} />
                                                            </Route>

                                                            <Route path={"/profile"}>
                                                                <Route index element={<ProfileFn />} />
                                                            </Route>

                                                            <Route path={"/forecast"}>
                                                                <Route
                                                                    index
                                                                    element={
                                                                        <Forecast
                                                                            userModel={userModel}
                                                                            supplierModel={supplierModel}
                                                                            vendorModel={vendorModel}
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                        />
                                                                    }
                                                                />

                                                                <Route path={":guid"} element={<ForecastDetailWrapper />} />
                                                            </Route>

                                                            <Route path={"/materials"}>
                                                                <Route
                                                                    index
                                                                    element={
                                                                        <Materials
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                            supplierModel={supplierModel}
                                                                            userModel={userModel}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                        />
                                                                    }
                                                                />
                                                            </Route>

                                                            <Route path={"/onboarding"}>
                                                                <Route
                                                                    index
                                                                    element={<Onboarding socket={socket} notifyFn={uiContext.notifyFn} />}
                                                                />
                                                            </Route>

                                                            <Route path={"/take_offs"}>
                                                                <Route
                                                                    index
                                                                    element={
                                                                        <TakeOffs
                                                                            socket={socket}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            userModel={userModel}
                                                                            supplierModel={supplierModel}
                                                                        />
                                                                    }
                                                                />

                                                                <Route path={":guid"} element={<TakeOffDetailWrapper />} />
                                                            </Route>

                                                            <Route path={"pick_lists"}>
                                                                <Route index element={<PickList />} />

                                                                <Route path={":guid"} element={<PickListDetailWrapper />} />
                                                            </Route>

                                                            <Route path={"packing_lists"}>
                                                                <Route
                                                                    index
                                                                    element={
                                                                        <PackingList
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            supplierModel={supplierModel}
                                                                            userModel={userModel}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                            vendorModel={vendorModel}
                                                                        />
                                                                    }
                                                                />

                                                                <Route path={":guid"} element={<PackingListDetailFn />} />

                                                                <Route path={":guid/old"} element={<PackingListDetailWrapper />} />
                                                            </Route>

                                                            <Route path={"/automation"}>
                                                                <Route
                                                                    index
                                                                    element={
                                                                        <Automation
                                                                            socket={socket}
                                                                            notifyFn={uiContext.notifyFn}
                                                                            setActivityIndicator={uiContext.setActivityIndicator}
                                                                            supplierModel={supplierModel}
                                                                            userModel={userModel}
                                                                            toggleSidebar={uiContext.toggleSidebar}
                                                                            setSidebarComponent={uiContext.setSidebarComponent}
                                                                        />
                                                                    }
                                                                />
                                                            </Route>

                                                            <Route path={"/wayfair"}>
                                                                <Route path={"logs"} element={<WayfairLogViewer />} />
                                                            </Route>

                                                            <Route path={"/logoff"} element={<LogOff />} />
                                                        </>
                                                    ) : null}
                                                </Routes>
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                    <div id={"rightSideBar"} className={(rightSideOpen ? menuClass + " .g-0" : "col-0 d-none") + " "}>
                                        {rightSideComponent}
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>

                    {process.env.NODE_ENV === "development" || showHiddenFeatures ? <AdminActionsCircle /> : null}
                </div>

                <Dock
                    size={0.15}
                    dockStyle={{
                        backgroundColor: "var(--main-bg-color)",
                        color: "var(--main-text-color)",
                    }}
                    position="bottom"
                    isVisible={isDockVisible}>
                    <IntercomProvider appId={INTERCOM_APP_ID}>
                        <HelpDock toggleHelpDock={toggleHelpDock} toggleCreateTicketModal={toggleCreateTicketModal} />
                    </IntercomProvider>
                </Dock>

                {showCreateTicketModal ? (
                    <CreateTicketModal closeModal={toggleCreateTicketModal} notifyFn={uiContext.notifyFn} socket={socket} />
                ) : null}

                <Modal
                    id={"mainReactModal"}
                    appElement={document.getElementById("root")!}
                    shouldCloseOnEsc={modalCloseOnEsc}
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={modalCloseOnOverlayClick}
                    className={modalContentClass}
                    overlayClassName={modalOverlayClass}
                    style={modalStyle}>
                    {modalComponent}
                </Modal>

                {sidebarMounted ? (
                    <OwSidebar isOpen={sidebarOpen} position={sidebarProps ? (!sidebarProps?.pullRight ? "left" : "right") : "right"}>
                        <ErrorBoundary
                            FallbackComponent={ErrorFallback}
                            onError={(error, componentStack) => {
                                console.log("Sidebar error", error);
                                console.log("Sidebar componentStack", componentStack);

                                // Report to DataDog
                                LogService.logReactError(error, componentStack, {
                                    source: "sidebar",
                                    userGuid: userModel?.guid,
                                    userName: userModel?.name,
                                    supplierGuid: supplierModel?.guid,
                                    vendorGuid: vendorModel?.guid,
                                    pathname: location.pathname,
                                    timestamp: new Date().toISOString(),
                                });
                            }}>
                            {sidebarComponent}
                        </ErrorBoundary>
                    </OwSidebar>
                ) : null}

                <ToastContainer />
            </CategoryContext.Provider>
        </AppContextProvider>
    );
}

export default App;
